import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    document.documentElement.style.backgroundColor = "white";
  }

  disconnect() {
    document.documentElement.style.backgroundColor = "";
  }

  updateText(event) {
    const selectedOption = event.target.selectedOptions[0];
    const locationCount = selectedOption.getAttribute("data_location_count");
    const textElement = document.getElementById('dynamic_text');

    if (locationCount) {
      textElement.innerHTML = `The Fuel Optimizer will leverage around ${locationCount} locations that updated their prices over the last 24 hours.`;
    }
  }
}
